import type React from 'react';

import { Iconify } from '@mfw/components';
import Box from '@mui/material/Box';

import { useNavigationContext } from '../../../context';
import { Logo } from '../../../components';

export interface SidebarHeaderProps {
  children?: React.ReactNode;
  className?: string;
}
const SidebarHeader = ({ children, className }: SidebarHeaderProps) => {
  const { isMobile, setNavigationOpen } = useNavigationContext();
  return (
    <Box display="flex" flexDirection="column" className={className}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={{ xs: 1, sm: 2 }}
        minHeight="71px"
        maxHeight="71px"
      >
        <Box display="flex" pr={1}>
          <Logo size="medium" />
          {children}
        </Box>
        {isMobile && (
          <Iconify
            onClick={() => setNavigationOpen(false)}
            icon="mdi:close-circle"
            size="large"
          />
        )}
      </Box>
    </Box>
  );
};

export default SidebarHeader;
